import React from 'react';
import {
  Typography,
  Divider,
  ListItem,
  ListItemAvatar,
  List,
  ListItemText,
  Button,
} from '@mui/material';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { getCloudfrontUrl } from '@/utils/cloudfront';
import { FALLBACK_INSPECTION_IMAGE } from '@/constants';
import { StructuresByUserGroupQuery } from '@/__generated__/graphql';
import { primary } from '@/theme/colors';
import { textButtonStyle } from '@/theme';

type Platform = {
  id: string;
  name: string;
  coverImagePath: string;
  description: string;
};

type Props = {
  platformsList: StructuresByUserGroupQuery['structuresByUserGroup'];
  handleDeleteConfirmationOpen?: (value: Platform) => void;
  imageStyles: Object;
  textAlign?: string;
};

type SubTextProps = {
  text: string | undefined;
};

const SubText = ({ text }: SubTextProps) => {
  return (
    <Typography fontSize={12} sx={{ display: 'inline', color: primary.gray }}>
      {text}
    </Typography>
  );
};

export const PlatformsListing = ({
  platformsList,
  handleDeleteConfirmationOpen,
  imageStyles,
  textAlign,
}: Props) => {
  return (
    <List sx={{ bgcolor: 'background.paper', overflowY: 'auto', height: '100%' }}>
      {platformsList?.map((platform, index) => (
        <>
          <ListItem
            key={platform.name}
            sx={{ alignItems: textAlign ?? 'center', justifyContent: 'space-between' }}
          >
            <ListItemAvatar>
              <img
                alt={platform.name}
                src={getCloudfrontUrl(platform.coverImagePath || FALLBACK_INSPECTION_IMAGE)}
                onError={(event) => {
                  const reference = event.currentTarget;
                  reference.src = FALLBACK_INSPECTION_IMAGE;
                }}
                crossOrigin="use-credentials"
                style={imageStyles}
              />
            </ListItemAvatar>
            <ListItemText
              sx={{ ml: '12px' }}
              primary={platform.name}
              secondary={<SubText text={platform.description} />}
            />
            {handleDeleteConfirmationOpen && (
              <Button
                data-testid={`delete-platform-button-${index}`}
                variant="text"
                sx={{ ...textButtonStyle }}
                startIcon={<DeleteOutlineRoundedIcon />}
                onClick={() => handleDeleteConfirmationOpen(platform)}
              >
                Remove Access
              </Button>
            )}
          </ListItem>
          <Divider />
        </>
      ))}
    </List>
  );
};
